import React from "react";

const PlanTabContent = ({ images, planName, eventTypeId: _eventTypeId, get: _get, post: _post, showToast: _showToast }) => {
  // Filter images that have this plan in their plan_details
  const filteredImages = images.filter((item) => {
    if (!item.plan_details || !Array.isArray(item.plan_details)) {
      return false;
    }
    
    // For "no plan", check if plan_id is null or plan_name is "no plan"
    if (planName === "no plan") {
      return item.plan_details.some(
        (planDetail) => planDetail.plan_id === null || planDetail.plan_name === "no plan"
      );
    }
    
    // For regular plans, match by plan_name
    return item.plan_details.some(
      (planDetail) => planDetail.plan_name === planName
    );
  });

  const displayName = planName === "no plan" ? "No Plan" : planName;

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">{displayName}</h2>

      {filteredImages.length === 0 ? (
        <div className="text-center py-12 text-gray-500">
          <p>No images found for this plan.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredImages.map((item) => {
            const image = item.image;

            return (
              <div
                key={image.id}
                className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200"
              >
                {/* Image Container - 16:9 Aspect Ratio */}
                <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
                  <img
                    src={image.img_sas_url || image.img_url}
                    alt={image.img_name || "Plan image"}
                    className="absolute top-0 left-0 w-full h-full object-cover"
                    onError={(e) => {
                      e.target.src = image.img_url; // Fallback to regular URL
                    }}
                  />
                </div>

                {/* Image Info */}
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-gray-800">
                    {image.img_name || "Untitled Image"}
                  </h3>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PlanTabContent;

